document.addEventListener("DOMContentLoaded", () => {
  const selected = []; // Array to store the selected value for each category

  const categoryLists = [
    document.querySelector(".av-config-area-options"),
    document.querySelector(".av-config-zone-options"),
    document.querySelector(".av-config-speaker-type-options"),
    document.querySelector(".av-config-audio-type-options"),
  ];

  const plusIcon = document.querySelectorAll(".av-config-accordion-icon");
  const noResultsMessage = document.getElementById("no-results-message");

  function addToArr(item, index) {
    if (item !== null && item !== "") {
      selected[index] = item;
    }
  }

  function removeFromArr(index) {
    selected[index] = null;
  }

  function highlightSelected(category, selectedItem) {
    category.querySelectorAll("li").forEach((item) => {
      item.classList.remove("av-config-highlight");
    });
    // Add the highlight class to the clicked item
    selectedItem.classList.add("av-config-highlight");
  }

  function toggleULVisability() {
    // Toggle visibility for each category's <ul> when the <h2> is clicked

    const categoryButtons = document.querySelectorAll(".av-config-h2-flex");
    categoryButtons.forEach((header, index) => {
      header.addEventListener("click", () => {
        const categoryList = header.nextElementSibling;
        categoryList.classList.toggle("visible");
        plusIcon[index].classList.toggle("active");
      });
    });
  }

  toggleULVisability();

  function showULOnWindowResize() {
    if (window.innerWidth < 768) {
      categoryLists.forEach((category, index) => {
        category.classList.remove("visible");
        plusIcon[index].classList.remove("active");
      });
    } else {
      categoryLists.forEach((category) => {
        category.classList.add("visible");
      });
    }
  }

  window.addEventListener("resize", showULOnWindowResize);
  showULOnWindowResize();

  categoryLists.forEach((category, index) => {
    category.querySelectorAll("li").forEach((item) => {
      const value = item.getAttribute("value");

      item.addEventListener("click", () => {
        if (value === "select") {
          removeFromArr(index);
        } else {
          addToArr(value, index);
        }

        highlightSelected(category, item);

        const button = category.previousElementSibling;
        button.value = item.textContent;

        let noResults = false;

        document.querySelectorAll(".av-config-product").forEach((product) => {
          const productTags = product.getAttribute("data-tags").split(" ");
          const matchesAllTags = selected.every((tag) => {
            return tag === null || productTags.includes(tag);
          });
          product.style.display = matchesAllTags ? "block" : "none";
          if (matchesAllTags) {
            noResults = true;
          }
        });
        noResultsMessage.style.display = noResults ? "none" : "block";
      });
    });
  });
});
